// extracted by mini-css-extract-plugin
export default {"container":"styles_container__HS0av","form":"styles_form__BypFa","title":"styles_title__zZtCC"};